import {Button} from "antd";
import {CustomModal} from "../../../../../components/modal";
import {StyledModalContentWrapper} from "../../../../../components/calls/upcoming-calls/call-card/call-card.style";
import {
  buildScheduleConflictModalCopy,
  type ScheduleConflictDetails,
} from "./email-automation-schedule-conflict";

interface ScheduleConflictModalProps {
  open: boolean;
  onClose: () => void;
  details: ScheduleConflictDetails | null;
}

export function ScheduleConflictModal({
  open,
  onClose,
  details,
}: ScheduleConflictModalProps) {
  if (!details) return null;

  const copy = buildScheduleConflictModalCopy(details);

  return (
    <CustomModal
      visibleState={open}
      title={copy.title}
      okFunc={onClose}
      cancelFunc={onClose}
      centered
      width={520}
      footerContent={[
        <Button key="got-it" size="small" type="primary" onClick={onClose}>
          Got it
        </Button>,
      ]}
    >
      <StyledModalContentWrapper>
        <p style={{margin: "0 0 16px"}}>{copy.lead}</p>
        {copy.offeringNames.length > 0 ? (
          <ul
            style={{
              margin: "0 0 16px",
              paddingLeft: 20,
              color: "#1c1726",
            }}
          >
            {copy.offeringNames.map((name) => (
              <li key={name} style={{marginBottom: 4}}>
                {name}
              </li>
            ))}
          </ul>
        ) : null}
        <p style={{margin: 0, color: "#595959", fontSize: 14}}>{copy.footerHint}</p>
      </StyledModalContentWrapper>
    </CustomModal>
  );
}
